var ATLLanguages = [];

/**
 * Load asynchronously the list of available languages from the API
 * @param {Function} complete The callback to execute once the languages have been loaded
 */
function loadATLLanguages(complete) {
    $.ajax({
        url: getApiURL("languages"),
        headers: { "Token": $.cookie('token_api') },
        data: {
            status: '!=inactive',
            items_per_page: 9999999 // return all languages
        },
        dataType: "json",
        success: function (data) {
            ATLLanguages = data.results;
            complete();
        },
        error: function (request, textStatus, errorThrown) {
            alert("Something went wrong while loading languages list: " + errorThrown);
        }
    });
}

/**
 * Get the list of language options as an HTML string
 * @param {String} selected The selected language
 */
function getLanguagesOptions(selected = '') {
    let options =  '';
    let language_other = true;
    ATLLanguages.forEach(language => {
        if (language.language === selected) {
            language_other = false;
        }
    });
    ATLLanguages.forEach(language => {
        if (language_other && language.language === 'Other') {
            options += '<option value="Other" selected>Other</option>';
        } else {
            options += `<option value='${language.language}' ${language.language === selected ? `selected=""` : ""}>${language.language}</option>`;
        }
    });

    return options;
}